import React, { Component } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Filters, Pagination, constants, jsonData, KeolisSpinner, moment, Base64} from './common/commonExport';
import {withRouter} from 'react-router';
import logo from '../../../src/assets/images/KeolisLogo.png';
import AuthService from './auth/authService';
import { loginAction } from "../actions/index";
import LoginComp from '../components/login';
import AuthComponent from '../components/authComp';
class Login extends React.Component {
    

    constructor(props) {
        
        super(props);
        this.Auth = new AuthService();
        this.state = { // setting default state
            username: '',
            password: '',
            logo:logo,
            submitted: false,
            impersonateUserId:''
        };
    }

    // setting values in state on typying
    handleChange(e) { // changing of username/passowrd
        const { name, value } = e.target;       
       this.setState({ [name]: value });        
    }

    handleSubmit(e){ // submit action on Login

        e.preventDefault();
        this.setState({ submitted: true });
        const { username, password,impersonateUserId } = this.state;        
        if (username && password) {
            this.props.onLogin('LoginProgress'); // login in progress action
            
            var encodedPassword = Base64.encode(this.state.password);
            this.Auth.login(this.state.username, encodedPassword, impersonateUserId) // check for authentication
            .then(res =>{
                var user = {...res,
                    impersonateUserId: impersonateUserId
                };
                if(user.success == false){               
                    this.props.onLogin('LoginError', user.errMsg); // error action
                } else {

                    this.props.onLogin('LoginSuccess', user); // login success action
                    const activeMenus = this.props.authDetails.activeMenus.map((m) => m.MenuType) ;
                    const hosMenu = constants.Menus.find((menu) => menu.Name == "HOS");
                    let isLogmenuActive = hosMenu && Array.isArray(activeMenus) && activeMenus.length > 0 ? activeMenus.includes(hosMenu.id) : false;
                    let componentPath =  constants.routes.defaultEmpRoute; // component for Employee
                    switch (user.role) {
                        case constants.roles.ADMIN_ROLE:
                            componentPath = impersonateUserId > 0? constants.routes.defaultEmpRoute:constants.routes.defaultAdminRoute; // default component to open for Admin                                                   
                            break;
                        case constants.roles.FRA_ROLE:  
                            componentPath= constants.routes.defaultFRARoute                                                                    
                            break;                    
                        default:
                            componentPath = isLogmenuActive ? constants.routes.defaultEmpHosRoute : constants.routes.defaultEmpRoute; // component for Employee
                    }
                    this.props.history.push(componentPath);
                }
            }).catch(err =>{ // if any error
                var errMsg = 'Failed to fetch';
                if(err.response && err.response.statusText){
                    errMsg  = err.response.statusText;
                }                
                this.props.onLogin('LoginError', errMsg); // error action
            })
        }
    }
    render() {   
        return (
            <AuthComponent />
        )
    }
}

function mapStateToProps(state) {

    return {
        authDetails:state.authState
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            onLogin:loginAction
        }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Login);
